export const AuthMethod = {
	EMAIL: "email",
	OAUTH: "oauth",
	SYSTEM: "system",
} as const;
export type AuthMethod = (typeof AuthMethod)[keyof typeof AuthMethod];

export const OAuthProvider = {
	GOOGLE: "google",
	MICROSOFT: "microsoft",
} as const;
export type OAuthProvider = (typeof OAuthProvider)[keyof typeof OAuthProvider];
